import type { DimeAutocompleteOption } from './dime-autocomplete-option.js';

export type DimeAutocompleteOptionGroup = { value: string; items: DimeAutocompleteOption[] };

/** Groups in the order they first appear; null when no option names a group. */
export function groupAutocompleteOptions(
  options: readonly DimeAutocompleteOption[],
): DimeAutocompleteOptionGroup[] | null {
  if (!options.some((option) => option.group)) return null;
  const groups = new Map<string, DimeAutocompleteOption[]>();
  for (const option of options) {
    const name = option.group ?? '';
    const members = groups.get(name);
    if (members) members.push(option);
    else groups.set(name, [option]);
  }
  return [...groups].map(([value, items]) => ({ value, items }));
}
